import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitManager } from "../SearchkitManager";
import { Utils } from "../support";

var mapValues = require("lodash/mapValues");

import { block } from "./block";
export var SearchkitComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchkitComponent, _React$Component);

  function SearchkitComponent(props) {
    var _this;

    _classCallCheck(this, SearchkitComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchkitComponent).call(this, props));
    _this.translations = {};
    _this.unmounted = false;
    _this.translate = _this.translate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchkitComponent, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      return null;
    }
  }, {
    key: "defineAccessor",
    value: function defineAccessor() {
      return null;
    }
  }, {
    key: "translate",
    value: function translate(key, interpolations) {
      var translation = this.searchkit.translate(key) || this.props.translations && this.props.translations[key] || this.translations[key] || key;
      return Utils.translate(translation, interpolations);
    }
  }, {
    key: "_getSearchkit",
    value: function _getSearchkit() {
      return this.props.searchkit || this.context["searchkit"];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._initAccessor();

      if (this.searchkit) {
        this.stateListenerUnsubscribe = this.searchkit.emitter.addListener(function () {
          if (!_this2.unmounted) {
            _this2.forceUpdate();
          }
        });
      }

      this.forceUpdate();
    }
  }, {
    key: "_initAccessor",
    value: function _initAccessor() {
      if (this.searchkit && !this.accessor) {
        this.accessor = this.defineAccessor();

        if (this.accessor) {
          this.accessor = this.searchkit.addAccessor(this.accessor);
          return true;
        }
      }

      if (!this.searchkit) {
        console.warn("No searchkit found in props or context for " + this.constructor["name"]);
      }

      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stateListenerUnsubscribe) {
        this.stateListenerUnsubscribe();
      }

      if (this.searchkit && this.accessor) {
        this.searchkit.removeAccessor(this.accessor);
      }

      this.unmounted = true;
    }
  }, {
    key: "getResults",
    value: function getResults() {
      return this.searchkit.results;
    }
  }, {
    key: "getHits",
    value: function getHits() {
      return this.searchkit.getHits();
    }
  }, {
    key: "getHitsCount",
    value: function getHitsCount() {
      return this.searchkit.getHitsCount();
    }
  }, {
    key: "hasHits",
    value: function hasHits() {
      return this.searchkit.hasHits();
    }
  }, {
    key: "hasHitsChanged",
    value: function hasHitsChanged() {
      return this.searchkit.hasHitsChanged();
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return this.searchkit.query;
    }
  }, {
    key: "isInitialLoading",
    value: function isInitialLoading() {
      return this.searchkit.initialLoading;
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.searchkit.loading;
    }
  }, {
    key: "getError",
    value: function getError() {
      return this.searchkit.error;
    }
  }, {
    key: "bemBlocks",
    get: function get() {
      return mapValues(this.defineBEMBlocks(), function (cssClass) {
        return block(cssClass).el;
      });
    }
  }, {
    key: "searchkit",
    get: function get() {
      return this._searchkit || (this._searchkit = this._getSearchkit());
    },
    set: function set(value) {
      this._searchkit = value;
    }
  }]);

  return SearchkitComponent;
}(React.Component);
SearchkitComponent.contextTypes = {
  searchkit: PropTypes.instanceOf(SearchkitManager)
};

SearchkitComponent.translationsPropType = function (translations) {
  return PropTypes.shape(mapValues(translations, function () {
    return PropTypes.string;
  }));
};

SearchkitComponent.propTypes = {
  mod: PropTypes.string,
  className: PropTypes.string,
  translations: PropTypes.objectOf(PropTypes.string),
  searchkit: PropTypes.instanceOf(SearchkitManager)
};